import React from "react";
import { modalOverrides, sponsorModal, textModal } from "./common";
export default [
    {
        width: "4%",
        height: "8.1%",
        left: "4.2%",
        top: "6.8%",
        label: "Chat With Reliaquest",
        isExternal: true,
        modalOverrides: textModal("fit-content"),
        modal: React.createElement(React.Fragment, null,
            React.createElement("h1", null, "The chat feature is now closed."),
            React.createElement("p", null, "Please contact sponsors using the contact forms."))
    },
    {
        width: "5.2%",
        height: "11.1%",
        left: "6.5%",
        top: "24.3%",
        label: "The CISOS guide to metrics that matter",
        isExternal: true,
        target: "_blank",
        href: "https://assets.swoogo.com/uploads/2162123-635c0ed49837a.pdf"
    },
    {
        width: "3.7%",
        height: "7.6%",
        left: "15.5%",
        top: "2.8%",
        label: "ReliaQuest Play Demo",
        isExternal: true,
        modalOverrides: modalOverrides,
        modal: React.createElement("div", { style: { height: "100%", width: "100%" } },
            React.createElement("iframe", { width: "100%", height: "100%", frameBorder: "0", src: "https://www.youtube.com/embed/6STVYytHygU?autoplay=1", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true }))
    },
    {
        width: "6%",
        height: "6.6%",
        left: "14.4%",
        top: "15.6%",
        label: "ReliaQuest Play Content",
        isExternal: true,
        modalOverrides: modalOverrides,
        modal: React.createElement("div", { style: { height: "100%", width: "100%" } },
            React.createElement("iframe", { width: "100%", height: "100%", frameBorder: "0", src: "https://player.vimeo.com/video/768179395?h=3bd62d495a&autoplay=1", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true }))
    },
    {
        width: "10%",
        height: "5.6%",
        left: "12.4%",
        top: "9.6%",
        label: "ReliaQuest - Social Media",
        isExternal: true,
        modalOverrides: textModal(),
        modal: sponsorModal("Booth 3", "ReliaQuest", React.createElement(React.Fragment, null, "ReliaQuest GreyMatter is a cloud-native security operations platform that is delivered as a service any time of the day, any place in the world. Built on an Open XDR architecture it offers bi- directional integration across any vendor solution, whether on-premises or in one or more clouds, to ingest data and automate actions. It brings together telemetry from any security and business solution to deliver singular visibility across the enterprise ecosystem and unifies detection, investigation, response and resilience, so organisations can accelerate incident response and manage cyber risk better. For more information visit:"), {
            twitter: "https://twitter.com/ReliaQuest",
            facebook: "https://www.facebook.com/ReliaQuest",
            linkedin: "https://www.linkedin.com/company/reliaquest/",
            youtube: "https://www.youtube.com/channel/UCdPuTyaN5bU3_GmCNFgzl3Q/featured",
            company: "https://www.reliaquest.com"
        })
    }
];
